var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.149 16.667q-2.958 0-5.219-1.813Q.67 13.042.024 10.23a.74.74 0 0 1 .125-.635.8.8 0 0 1 .562-.323.83.83 0 0 1 .625.166q.27.21.375.563a6.54 6.54 0 0 0 2.344 3.594Q5.837 15 8.15 15q2.79 0 4.729-1.937 1.938-1.938 1.938-4.73 0-2.79-1.938-4.729-1.937-1.937-4.73-1.937a6.5 6.5 0 0 0-3.322.885A6.5 6.5 0 0 0 2.399 5h1.583q.354 0 .594.24t.24.593-.24.594a.8.8 0 0 1-.594.24H1.15a.86.86 0 0 1-.73-.365.8.8 0 0 1-.124-.781q.875-2.46 3.02-3.99T8.15 0q1.73 0 3.25.656a8.4 8.4 0 0 1 2.646 1.781 8.4 8.4 0 0 1 1.78 2.646 8.1 8.1 0 0 1 .657 3.25 8.1 8.1 0 0 1-.656 3.25 8.4 8.4 0 0 1-1.781 2.646A8.4 8.4 0 0 1 11.4 16.01a8.1 8.1 0 0 1-3.25.657M8.982 8l2.084 2.083a.8.8 0 0 1 .229.584.8.8 0 0 1-.23.583.8.8 0 0 1-.583.23.8.8 0 0 1-.583-.23L7.565 8.917a.83.83 0 0 1-.25-.604V5q0-.354.24-.594t.594-.24.594.24.24.594z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history_icon.91f6115b8178d534ed8a3ac043172f82.svg";
export { ForwardRef as ReactComponent };